import { createNotImplementedMethod } from "../utils";
var NotImplementedActivityRepository = /** @class */ (function () {
    function NotImplementedActivityRepository() {
        this.getActivity = createNotImplementedMethod();
    }
    return NotImplementedActivityRepository;
}());
export { NotImplementedActivityRepository };
